import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { TokenService } from '../services/TokenService';

const tokenService = new TokenService();

// Check if the user is authenticated (by checking for the token)
const isAuthenticated = () => { return !tokenService.hasTokenExpired(); };

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  localStorage.setItem("LastUrl", document.location.href);
  
    // If not authenticated, redirect to the sign-in page
  if (!isAuthenticated()) {
    return <Navigate to="/signin" replace state={{ from: location.pathname + location.search + location.hash }} />;
  }

  // If authenticated, render the children (protected component)
  return <>{children}</>;
};

export default ProtectedRoute;
